// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notify-item .active[data-v-4f95f38a] {\n  color: #16181b;\n  background-color: #f8f9fa;\n}", ""]);
// Exports
module.exports = exports;
